import { UrlUtils } from '@atlassian/mpac-utils';
import { Map, OrderedSet } from 'immutable';

import {
  fromAddonDiscoveryAppMappings,
  fromAddonDiscoverySortMappings,
} from '../../../constants/mappings';
import { DISCOVER } from '../../../constants/perspectives';

const applicationSortSilter = () =>
  Map({
    match: (filters) => filters.has('product') && filters.has('sort'),
    resolveMetricsKey: (metrics) => metrics.applicationSilter,
    resolvePathAndQuery: ({ links, filters }) =>
      Map({
        path: UrlUtils.resolveUrlFromTemplateAndParameters({
          template: links.applicationSilter.href,
          parameters: {
            application:
              fromAddonDiscoveryAppMappings().get(filters.get('product')) || filters.get('product'),
            silter: fromAddonDiscoverySortMappings.get(filters.get('sort')) || filters.get('sort'),
          },
        }),
        query: filters.delete('product').delete('sort'),
      }),
  });

const applicationCloudFortifiedSilter = () =>
  Map({
    match: (filters) =>
      filters.has('product') &&
      filters.get('moreFilters') &&
      filters.get('moreFilters').includes('cloudFortified'),
    resolveMetricsKey: (metrics) => metrics.applicationSilter,
    resolvePathAndQuery: ({ links, filters }) =>
      Map({
        path: UrlUtils.resolveUrlFromTemplateAndParameters({
          template: links.applicationSilter.href,
          parameters: {
            application:
              fromAddonDiscoveryAppMappings().get(filters.get('product')) || filters.get('product'),
            silter: 'cloud-fortified',
          },
        }),
        query: filters
          .delete('product')
          .update('moreFilters', (moreFilters) => moreFilters.delete('cloudFortified')),
      }),
  });

const sortSilter = Map({
  match: (filters) => filters.has('sort'),
  resolveMetricsKey: (metrics) => metrics.silter,
  resolvePathAndQuery: ({ links, filters }) =>
    Map({
      path: UrlUtils.resolveUrlFromTemplateAndParameters({
        template: links.silter.href,
        parameters: {
          silter: fromAddonDiscoverySortMappings.get(filters.get('sort')) || filters.get('sort'),
        },
      }),
      query: filters.delete('sort'),
    }),
});

const cloudFortifiedSilter = Map({
  match: (filters) => {
    const moreFilters = filters.get('moreFilters');
    return moreFilters ? moreFilters.includes('cloudFortified') : false;
  },
  resolveMetricsKey: (metrics) => metrics.silter,
  resolvePathAndQuery: ({ links, filters }) => {
    return Map({
      path: UrlUtils.resolveUrlFromTemplateAndParameters({
        template: links.silter.href,
        parameters: { silter: 'cloud-fortified' },
      }),
      query: filters.update('moreFilters', (moreFilters) => moreFilters.delete('cloudFortified')),
    });
  },
});

const search = Map({
  match: () => true,
  resolveMetricsKey: (metrics) => metrics.search,
  resolvePathAndQuery: ({ links, filters }) =>
    Map({
      path: links.search.href,
      query: filters,
    }),
});

// Order is important - first matched will be returned
const toSearchOptions = () =>
  OrderedSet([
    applicationSortSilter(),
    applicationCloudFortifiedSilter(),
    sortSilter,
    cloudFortifiedSilter,
    search,
  ]);

const toDiscoverOptions = () =>
  OrderedSet([
    // Application link
    Map({
      match: (filters) => filters.has('product'),
      resolveMetricsKey: (metrics) => metrics.application,
      resolvePathAndQuery: ({ links, filters }) =>
        Map({
          path: UrlUtils.resolveUrlFromTemplateAndParameters({
            template: links.application.href,
            parameters: {
              application:
                fromAddonDiscoveryAppMappings().get(filters.get('product')) ||
                filters.get('product'),
            },
          }),
          query: filters.delete('product'),
        }),
    }),
    Map({
      match: () => true,
      resolveMetricsKey: (metrics) => metrics.discover,
      resolvePathAndQuery: ({ links, filters }) =>
        Map({
          path: links.home.href,
          query: filters,
        }),
    }),
  ]);

export function resolvePathAndQuery({ filters, links, toPerspective }) {
  const options = toPerspective === DISCOVER ? toDiscoverOptions : toSearchOptions;
  return (
    // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
    options()
      // @ts-ignore MC-2850
      .find((o) => o.get('match')(filters))
      .get('resolvePathAndQuery')({ links, filters })
      .update('query', (query) =>
        query.update(
          'product',
          (productFilter) => fromAddonDiscoveryAppMappings().get(productFilter) || productFilter
        )
      )
  );
}

export function resolveMetricsKey({ filters, metrics, perspective }) {
  const options = perspective === DISCOVER ? toDiscoverOptions : toSearchOptions;
  // @ts-ignore MC-2850
  return (
    // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
    options()
      // @ts-ignore MC-2850
      .find((o) => o.get('match')(filters))
      .get('resolveMetricsKey')(metrics)
  );
}
